import { useState, type FormEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { adminLogin, isAdminLogged } from "@/lib/auth";
import { ApiError } from "@/lib/api";
import { Wordmark } from "@/components/ui/Wordmark";
import { Field } from "@/components/funnel/Field";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/admin/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (isAdminLogged()) {
    navigate(from, { replace: true });
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!email || !password) return;
    setSubmitting(true);
    try {
      const res = await adminLogin(email, password);
      if (res.mustChangePassword) {
        navigate("/admin/settings", { replace: true, state: { mustChange: true } });
      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("E-mail ou senha incorretos.");
      } else if (err instanceof ApiError && err.status === 429) {
        setError("Muitas tentativas. Aguarde alguns minutos.");
      } else {
        setError("Não conseguimos entrar agora. Tente novamente.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="adm-login">
      <form className="adm-login-card" onSubmit={submit} noValidate>
        <div className="adm-login-brand">
          <Wordmark />
        </div>
        <h1 className="adm-login-title">Painel Administrativo</h1>
        <p className="adm-login-sub">Acesse com seu e-mail e senha.</p>

        {error && <div className="adm-login-error">{error}</div>}

        <div className="fx-form" style={{ margin: 0 }}>
          <Field label="E-mail" type="email" value={email} onChange={setEmail} autoComplete="username" />
          <Field
            label="Senha"
            type="password"
            value={password}
            onChange={setPassword}
            autoComplete="current-password"
          />
        </div>

        <div style={{ marginTop: 22 }}>
          <button
            type="submit"
            className={`btn btn-primary btn-lg ${submitting ? "is-wait" : ""}`}
            disabled={submitting}
            style={{ width: "100%", justifyContent: "center" }}
          >
            {submitting ? "Entrando…" : "Entrar"} <span className="arr">→</span>
          </button>
        </div>
      </form>
    </div>
  );
}
